
    import './styles.scoped.css';
    export default {
  "resizable-box": "awsui_resizable-box_cufu9_ta8ss_149",
  "cursor-active": "awsui_cursor-active_cufu9_ta8ss_153",
  "resizable-box-handle": "awsui_resizable-box-handle_cufu9_ta8ss_167",
  "resize-active": "awsui_resize-active_cufu9_ta8ss_176"
};
  